
import Graph from './graph';
import ContentTooltip from '../tooltips/content-tooltip.vue';
const wideColumn = 'col-12 col-md-10 offset-md-1';

const jsdom = require('jsdom');

export default {
  name: 'HContentBody',

  props: {
    html: {
      type: String,
      default: '',
    },

    definedProperties: {
      type: Array,
      default: () => [],
    },

    propsValue: {
      type: Object,
      default: () => ({}),
    },

    contentPlaceholders: {
      type: Object,
      default: () => ({}),
    },

    calculator: {
      type: Object,
    },

    widget: {
      type: Object,
    },
  },

  data() {
    return {
      parsedJsonLd: new Set()
    };
  },

  computed: {
    doc() {
      let doc;

      if (typeof window !== 'undefined') {
        doc = window.document;
      } else {
        const dom = new jsdom.JSDOM();
        doc = dom.window.document;
      }

      return doc;
    },

    dynamicComponent() {
      return {
        name: 'DynamicComponent',
        template: `<div class="dynamicComponent"><div class="container removeMarginBottom">${this.formatHTML}</div></div>`,
        /* define props as needed */
        props: this.definedProperties,
        components: {
          Graph,
          ContentTooltip,
          ...(this.calculator ? { Inlinecalculator: this.calculator } : {}),
          ...(this.widget ? { Widget: this.widget } : {}),
        },
      };
    },

    // Inject the header styles with the correct typography
    formatHTML() {
      let content = this.html;

      content = this.wrapNodes(content);
      content = this.processPictures(content);
      content = this.processIframeContainer(content);
      content = this.addHeadingsCSSClases(content);
      content = this.insertPlaceholders(content);
      content = this.processTables(content);

      

      const fragment = this.doc.createDocumentFragment();
      const contentEl = this.doc.createElement('div');
      contentEl.innerHTML = content;

      fragment.appendChild(contentEl);

      fragment.querySelectorAll('script[type="application/ld+json"]').forEach((element) => {
        const jsonText = element.textContent;
        if (jsonText && jsonText.trim().length > 0) {
          try {
            this.parsedJsonLd.add(JSON.parse(jsonText));
          } catch (e) {
            // Invalid JSON-LD; skip adding to parsedJsonLd
          }
        }
        element.remove();
      });

      return contentEl.innerHTML;
    },
  },

  methods: {
    addHeadingsCSSClases(content) {
      const headingsLevels = {
        h2: 'text-h4 text-md-h3 mb-1 mb-md-3',
        h3: 'text-h5 text-md-h4 mb-1 mb-md-3',
        h4: 'text-subtitle-4 text-md-subtitle-3 mb-1 mb-md-2',
        h5: 'text-subtitle-4 text-md-subtitle-3 mb-1 mb-md-2',
      };

      for (const [level, classes] of Object.entries(headingsLevels)) {
        content = content.replace(
          new RegExp(`<${level}`, 'gi'),
          `<${level} class="${classes}"`,
        );
      }

      return content;
    },

    processPictures(content) {
      content = content.replace(
        // eslint-disable-next-line prefer-regex-literals
        new RegExp(`<picture>`, 'gi'),
        `<div class="row hContentBody__image"><div class="${wideColumn}"><picture>`,
      );

      content = content.replace(
        // eslint-disable-next-line prefer-regex-literals
        new RegExp(`</picture>`, 'gi'),
        `</picture></div></div>`,
      );

      return content;
    },

    wrapNodes(HFcontent) {
      const textTags = ['h2', 'h3', 'h4', 'h5', 'h6', 'p', 'ul', 'ol', 'table'];

      const fragment = this.doc.createDocumentFragment();

      const content = this.doc.createElement('div');
      content.innerHTML = HFcontent;

      fragment.appendChild(content);

      const div = this.doc.createElement('div');

      textTags.forEach((tag) => {
        const nodes = fragment.querySelectorAll(tag);

        nodes.forEach((item) => {
          const row = this.doc.createElement('div');
          row.classList.add('row');

          const wrapper = this.doc.createElement('div');
          wrapper.classList.add('col-12');
          wrapper.classList.add('col-md-10');
          wrapper.classList.add('offset-md-1');
          wrapper.appendChild(item.cloneNode(true));

          row.appendChild(wrapper);

          if (
            item.parentElement.tagName.toLowerCase() !== 'td' &&
            item.parentElement.tagName.toLowerCase() !== 'th'
          ) {
            item.parentElement.replaceChild(row, item);
          }
        });
        div.appendChild(fragment.cloneNode(true));
      });
      return content.innerHTML;
    },

    processIframeContainer(content) {
      content = content.replace(
        // eslint-disable-next-line prefer-regex-literals
        new RegExp(`<div class="video-container">`, 'gi'),
        `<div class="row"><div class="${wideColumn} video-container"><div class="iframe-container my-md-4">`,
      );

      content = content.replace(
        // eslint-disable-next-line prefer-regex-literals
        new RegExp(`</iframe>`, 'gi'),
        `</iframe></div></div>`,
      );


      return content;
    },

    insertPlaceholders(content) {
      if (!Object.keys(this.contentPlaceholders).length) {
        return content;
      }

      Object.keys(this.contentPlaceholders).forEach((key) => {
        content = content.replaceAll(key, this.contentPlaceholders[key]);
      });

      return content;
    },
    processTables(HFcontent) {
      // this block of code is specific for the takeaway tables
      const regex =
        /<table\s*>\s*<tbody\s*>\s*<tr\s*>\s*<td\s*>[\s\S]*?<\/td>\s*<\/tr>\s*<\/tbody>\s*<\/table>/g;
      const tables = HFcontent.match(regex);

      if (tables) {
        tables.forEach((table) => {
          const div = this.doc.createElement('div');

          const content = this.doc.createElement('div');
          content.innerHTML = table;
          content.classList.add('takeaway');
          const tdCount = content.querySelectorAll('td').length;

          content.style.setProperty(
            '--columns',
            Math.ceil(tdCount / content.querySelectorAll('tr').length),
          ); // related to LoC 393
          div.appendChild(content);
          HFcontent = HFcontent.replace(table, div.innerHTML);
        });
      }

      return HFcontent;
    },
  },

  render(createElement) {
    const dynamicComponent = this.dynamicComponent;

    if (process.client) {
      this.dynamicComponent;
      this.$meta().refresh();
    }

    return createElement(dynamicComponent, {
      /* pass prop values as needed */
      props: this.propsValue,
      on: {
        placeholder: (placeholderId) => {
          this.$emit('placeholder', placeholderId);
        },
      },
    });
  },

  jsonld() {
    if(this.parsedJsonLd.size > 0) {
      return Array.from(this.parsedJsonLd);
    } else {
      return {};
    }
  }
};
